module.exports = __webpack_public_path__ + "b06871f281fee6b241d60582ae9369b9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1495
// module chunks = 0